import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import checkIcon from '../../../assets/svg/check-icon.svg';
import calendar from '../../../assets/svg/calendar.svg';
import clockIcon from '../../../assets/svg/clock-icon.svg'

import Checkbox from '../../../components/forms/fields/checkbox';
import { getDetailedGroupPaymentMethods, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange } from '../helper';
import ErrorModal from '../../../components/errorModal';
import InfoModal from '../../../components/infoModal';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class PaysonModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/patient/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const paymentData = result?.paymentData ?? null;
                const caseData = result?.caseData ?? null;
                const groupData = result?.groupData ?? null;
                const eventData = result?.eventData ?? null;
                if (!paymentData || paymentData?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: paymentData, caseData: caseData, groupData: groupData, eventData: eventData }, () => {
                    this.startPayment();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }


    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }

    }

    startPayment = () => {
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) return;

        let data = {
            lang: this.props.lang,
            paymentId: paymentId
        };

        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/payson/start-payment`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                let setObj = {
                    loading: false
                };
                let scriptSrc = result?.snippet ? result.snippet.split('<script')[1].replace("type='text/javascript' src='", "").replace("'></script>", "") : null;
                setObj.htmlSnippet = result?.snippet;

                this.setState(setObj, () => {
                    if (this.script) {
                        this.script.remove();
                    }
                    var ref = window?.document?.getElementsByTagName("script")?.[0];
                    var script = window?.document?.createElement("script");
                    script.src = scriptSrc;
                    this.script = script;

                    ref.parentNode.insertBefore(script, ref);
                });
            })
        })
    }


    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        return (
            <>
                <Modal isOpen={isOpen} centered className='payson-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Payment'.translate(this.props.lang)}

                    </ModalHeader>

                    <ModalBody>
                        <div dangerouslySetInnerHTML={{ __html: this.state.htmlSnippet }} onChange={() => { }}></div>
                    </ModalBody>

                </Modal>


                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}
                {
                    this.state.successMessage ?
                        <InfoModal
                            isOpen={this.state.successMessage}
                            toggle={() => this.setState({ successMessage: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.successMessage?.translate(this.props.lang)}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.onClose()
                                }}>{'Close'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null

                }
            </>
        );
    }
}


export default PaysonModal;